import { useRef, useState } from 'react'
import { submitForm } from '~/shared/lib/form-utils'

/**
 * Tracks which follow-up action (e.g. publish/unlist) a submit button
 * requested. `trigger` records the action and submits the form, `consume`
 * reads and clears it inside the submit handler (and when the submit is
 * refused, so a later plain save does not publish), and `action` drives busy
 * labels while the submission is in flight.
 */
export function useAfterSaveAction<T extends string>() {
  const [action, setAction] = useState<T | null>(null)
  const actionRef = useRef<T | null>(null)

  const trigger = (form: Parameters<typeof submitForm>[0], next: T) => {
    actionRef.current = next
    setAction(next)
    return submitForm(form)
  }

  const consume = (): T | null => {
    const current = actionRef.current
    actionRef.current = null
    setAction(null)
    return current
  }

  return { action, trigger, consume }
}
